export const RATING_FACET_ALL_REVIEWED =
  'left_hand_facet_rating.rating_facet_all_reviewed';

export const RATING_FACET_OPTION = 'left_hand_facet_rating.rating_facet_option';
